"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "primiero-san-martino-di-castrozza": {
    "847296b6": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "fol": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9dd74279": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "forno": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "814b12a3": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "isolabella": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4772f419": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "navoi": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efe4ca45": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "ormanico": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7056a65d": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3ff5cb0": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "primiero": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9bc6f6ac": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "sangrilla": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0438a840": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "toe": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "579dd04f": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "skipSearch": false
    }],
    "valmesta": [{
      "hkey": "86709203",
      "slug": "primiero-san-martino-di-castrozza",
      "name": "Primiero San Martino di Castrozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;